import {connect} from 'react-redux';
import Chart from './chart';

function mapsStateToProps(state) {
    return {
        data: state.dashboard.chart_data
    }
}

export default connect(() => (mapsStateToProps), {})(Chart);